import React, { useMemo, useState } from "react";
import SalaryDetail from "../../FinancialReport/Salary/SalaryDetail/SalaryDetail";
import "./SalaryApprovalDetail.css";

const SalaryApprovalDetail = ({ department, onBack }) => {
  const [showConfirmApprove, setShowConfirmApprove] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectComment, setRejectComment] = useState("");
  const [rejectCommentError, setRejectCommentError] = useState("");

  const approvalStatus = useMemo(() => {
    const statuses = (department?.approvers || []).map((a) => a.status);
    const hasRejected = statuses.some((s) => s === "Отклонено");
    const hasPending = statuses.some((s) => s === "На рассмотрении");
    const allApproved =
      statuses.length > 0 && statuses.every((s) => s === "Согласован");
    if (hasRejected) return "rejected";
    if (allApproved) return "approved";
    if (hasPending) return "pending";
    return "neutral";
  }, [department?.approvers]);

  const handleConfirmApprove = () => {
    // TODO: Подключить API согласования шага salary approval.
    setShowConfirmApprove(false);
    if (onBack) onBack();
  };

  const handleConfirmReject = () => {
    if (!rejectComment.trim()) {
      setRejectCommentError("Комментарий обязателен для заполнения");
      return;
    }
    // TODO: Подключить API отклонения шага salary approval с комментарием.
    setShowRejectModal(false);
    setRejectComment("");
    setRejectCommentError("");
    if (onBack) onBack();
  };

  const handleCancelReject = () => {
    setShowRejectModal(false);
    setRejectComment("");
    setRejectCommentError("");
  };

  return (
    <div>
      <SalaryDetail
        department={department}
        onBack={onBack}
        initialMonth={department?.date}
        readOnlyMode
        approvalId={department?.approvalId}
        backButtonLabel="Согласование зарплаты"
        customActions={
          approvalStatus === "pending" ? (
            <>
              <button
                className="salary-detail__button salary-detail__button--reset"
                onClick={() => setShowRejectModal(true)}
                style={{
                  backgroundColor: "#fff",
                  color: "#ff4d4f",
                  border: "1px solid #ff4d4f",
                }}
              >
                Отклонить
              </button>
              <button
                className="salary-detail__button salary-detail__button--submit"
                onClick={() => setShowConfirmApprove(true)}
              >
                Согласовать
              </button>
            </>
          ) : null
        }
      />

      {showConfirmApprove && (
        <div className="popup-overlay" onClick={() => setShowConfirmApprove(false)}>
          <div className="popup popup-confirm" onClick={(e) => e.stopPropagation()}>
            <p className="popup-text">
              Вы уверены, что хотите согласовать зарплату для отдела "
              {department?.name}"?
            </p>
            <div className="popup-buttons">
              <button
                className="popup-button popup-button-cancel"
                onClick={() => setShowConfirmApprove(false)}
              >
                Отмена
              </button>
              <button
                className="popup-button popup-button-confirm popup-button-confirm--approve"
                onClick={handleConfirmApprove}
              >
                Согласовать
              </button>
            </div>
          </div>
        </div>
      )}

      {showRejectModal && (
        <div className="popup-overlay" onClick={handleCancelReject}>
          <div className="popup popup-reject" onClick={(e) => e.stopPropagation()}>
            <h3 className="popup-reject__title">Отклонение зарплаты</h3>
            <p className="popup-reject__subtitle">
              Вы уверены, что хотите отклонить зарплату для отдела "
              {department?.name}"?
            </p>
            <div className="popup-reject__comment-section">
              <label className="popup-reject__label">
                Комментарий <span className="popup-reject__required">*</span>
              </label>
              <textarea
                className={`popup-reject__textarea ${
                  rejectCommentError ? "popup-reject__textarea--error" : ""
                }`}
                value={rejectComment}
                onChange={(e) => {
                  setRejectComment(e.target.value);
                  if (rejectCommentError) setRejectCommentError("");
                }}
                placeholder="Укажите причину отклонения..."
                rows={4}
              />
              {rejectCommentError && (
                <span className="popup-reject__error">{rejectCommentError}</span>
              )}
            </div>
            <div className="popup-buttons">
              <button
                className="popup-button popup-button-cancel"
                onClick={handleCancelReject}
              >
                Отмена
              </button>
              <button
                className="popup-button popup-button-confirm"
                onClick={handleConfirmReject}
              >
                Отклонить
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SalaryApprovalDetail;
